export const stripFSChars = (name: string): string => name.replace(/[/\\?%*:|"<>]/g, '-');

export function createBlobFromBase64(base64: string, type: 'application/pdf' = 'application/pdf') {
  const raw = window.atob(base64);
  const blobArray = new Uint8Array(new ArrayBuffer(raw.length));
  for (let i = 0; i < raw.length; i++) {
    blobArray[i] = raw.charCodeAt(i);
  }
  return window.URL.createObjectURL(new Blob([blobArray], {type}));
}